import '@fancyapps/fancybox/dist/jquery.fancybox.min.css';
import $ from './jquery-global.js';
import '@fancyapps/fancybox';

// По умолчанию превью скрыты до клика по кнопке «сетка»; ось y — колонка справа.
$.extend(true, $.fancybox.defaults.thumbs, {
    autoStart: true,
    axis: 'x',
});
